
<div :class="prefixCls" v-show="show"><slot></slot></div>
